import axios from "axios";
import { useApi } from "../hooks/useApi";
import { handleAxiosError } from "../hooks/handleErrorAfterCallApi";

const api = useApi();

export async function getTrocsPropositionsList() {
  try {
    const response = await api.get(`trocs-propositions-resident/list`);

    return response;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      handleAxiosError(error); // Appelle handleAxiosError avec l'erreur de type AxiosError
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw error;
    }

    throw error; // Relance l'erreur
  }
}

export async function AcceptTrocProposal(travTrocId: number, resTrocId: number) {
  try {
    const response = await api.put(`trocs-propositions-resident/accepting-trav-troc/${travTrocId}-vs-res-troc/${resTrocId}`);
    return response.status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`Une erreur est suvenue. Rééssayez plus tard.`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function declineTrocProposal(travTrocId: number, resTrocId: number) {
  try {
    const response = await api.put(`trocs-propositions-resident/declining-trav-troc/${travTrocId}-vs-res-troc/${resTrocId}`);
    return response.status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function deleteTrocProposal(travTrocId: number, resTrocId: number) {
  try {
    const response = await api.delete(`trocs-propositions-resident/deleting-trav-troc/${travTrocId}-vs-res-troc/${resTrocId}`);

    return response.status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 403:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    } else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function shareExpOfRes(data: { content: string }, resTrocId: number, travTrocId: number) {
  try {
    const response = await api.put(`trocs-propositions-resident/trocRId/${resTrocId}/trocTId/${travTrocId}/share-exp`, data);
    return response.status;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      } 
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function trocDoneOfRes(resTrocId: number, travTrocId: number) {
  try {
    const response = await api.put(`trocs-propositions-resident/trocRId/${resTrocId}/trocTId/${travTrocId}/service-done`);
    return response.status;

  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      } 
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}